var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"away-page-assignment-modal","title":_vm.$t('ENTITLEMENT.DETAILS'),"title-class":"h4 font-weight-bold","lazy":"","size":"lg","hide-footer":""}},[_c('div',{staticClass:"d-flex flex-column p-5"},[_c('IndividualEmployeeAwayAssignmentForm',{on:{"onSubmitClicked":_vm.submitForm}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }